import { MemoryContract } from '@terra/shared-contracts-memory';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'ai';

export const memoryClient = createTerraOrpcClient({
  contract: MemoryContract,
  serviceName: SERVICE_NAME,
});
